module.exports = __webpack_public_path__ + "img/artiBanner.e902561f.jpg";